<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Usuario">
          <b-form>
            <b-form-group
              label="Contraseña Actual"
              label-for="currentPass"
              :label-cols="labelCols">
              <b-form-input 
                id="currentPass"
                v-model.trim="$v.currentPass.$model" 
                type="password"
                @blur.native="validate"
                @focus.native="$event.target.select()">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nueva Contraseña"
              label-for="password"
              :label-cols="labelCols">
              <b-form-input 
                id="password"
                v-model.trim="$v.password.$model" 
                :state="passwordValido"
                type="password"
                @blur.native="validate"
                @focus.native="$event.target.select()">
              </b-form-input>
              <b-form-invalid-feedback id="passwordFeedback">
                {{ passwordInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Confirme la Contraseña"
              label-for="confirmedPass"
              :label-cols="labelCols">
              <b-form-input 
                id="confirmedPass"
                v-model.trim="$v.confirmedPass.$model" 
                :state="confirmedPassValido"
                type="password"
                @blur.native="validate"
                @focus.native="$event.target.select()"
                @keyup.enter.native.prevent="save">
              </b-form-input>
              <b-form-invalid-feedback id="confirmedPassFeedback">
                {{ confirmedPassInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'Perfil',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      currentPass: '',
      password: '',
      confirmedPass: '',

      noValidar: true,
      currentPassValido: null,
      currentPassInvalidoMsj: '',
      passwordValido: null,
      passwordInvalidoMsj: '',
      confirmedPassValido: null,
      confirmedPassInvalidoMsj: '',

      labelCols: 2
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "password" || validarTodos) {
        if (this.$v.password.$error) {
          this.passwordValido = false;
          if (!this.$v.password.required) {
            this.passwordInvalidoMsj = 'Debe ingresar la nueva contraseña.';
          } else if (!this.$v.password.minLength || !this.$v.password.maxLength || !this.$v.password.strongPass) {
            this.passwordInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
            // this.passwordInvalidoMsj = 'La contraseña debe contener entre 8 y 15 caracteres.';
          }
          /*
          } else if (!this.$v.pass.minLength || !this.$v.pass.maxLength || !this.$v.pass.strongPass) {
            this.passInvalidoMsj = 'El password debe contener entre 8 y 15 caracteres, y al menos un número, una minúscula y una mayúscula.';
          }
          */
        } else {
          this.passwordValido = null;
          this.passwordInvalidoMsj = '';
        }
      }

      if (campo == "confirmedPass" || validarTodos) {
        if (this.$v.confirmedPass.$error) {
          this.confirmedPassValido = false;
          if (!this.$v.confirmedPass.sameAs) {
            this.confirmedPassInvalidoMsj = 'La nueva contraseña no coincide con su confirmación.';
          }
        } else {
          this.confirmedPassValido = null;
          this.confirmedPassInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();

        let params = {
          current: this.currentPass,
          pass: this.password
        }

        this.$store.dispatch('usuarioPerfil/updatePassword', params)
          .then(()  => this.showModalMsj('La contraseña se actualizó con éxito.', this.goBack, this.goBack, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  watch: {
  },
  validations: {
    currentPass: {},
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(15),
      strongPass: function(value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        // const containsSpecial = /[#?!@$%^&*-]/.test(value);
        
        // return containsUppercase && containsLowercase && containsNumber && containsSpecial;
        return containsUppercase & containsLowercase & containsNumber;
      }
      /*
      strongPass(pass) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(pass);
      } 
      */
    },
    confirmedPass: {
      sameAs: sameAs('password')
    },    
  },  
}
</script>

<style>
</style>
